import { findIndex } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import TrackedClick from '../Analytics/TrackedClick';
import { getClickAttrs } from '../Analytics/gtag';

const _ = { findIndex };

const TabBar = (props) => {
    const {
        tabs,
        showLabels,
        transparent,
        noContainer,
        noBorder,
        noPadding,
        centerTabs,
        handleTabClick,
        handleTabClickV3,
        eventName,
        clickCategory,
        clickLocation = 'Tab Bar',
        disabledTabClick = false,
        'data-testid': dataTestId,
    } = props;

    const onTabClick = (ev, tab, i) => {
        if (disabledTabClick) {
            return;
        }
        const hasTabIdentifier = tab.id || i;
        if (handleTabClick) {
            handleTabClick(ev, hasTabIdentifier);
        }
        if (handleTabClickV3) {
            handleTabClickV3({ tabId: hasTabIdentifier });
        }
    };

    const currentTabIndex = _.findIndex(tabs, { active: true });
    const selectedtab = (currentTabIndex !== -1) && props.tabs[currentTabIndex];

    return (
        <div className={`tab-bar ${transparent ? '' : 'bg-white'} ${noBorder ? 'bb0' : ''} ${noPadding ? 'pt0' : ''}`} data-testid={dataTestId}>
            <div className={`${noContainer ? '' : 'container'} pb0 auto-scroll ${centerTabs ? 'justify-content-center' : null}`}>
                {tabs.map((tab, i) => {
                    if (tab.showTab) {
                        return (
                            <React.Fragment key={`tab-element-${i}`}>
                                {tab.newSegment && (
                                    <div className={`btn-tab ${showLabels ? 'labelled' : ''}`}>
                                        <div className={`border-left fill-height`} />
                                    </div>
                                )}
                                <TrackedClick
                                    eventName={eventName}
                                    label={typeof (tab.title) === 'string' ? tab.title : tab.titleName || 'unknown'}
                                    traits={
                                        {
                                            fromTab: typeof (selectedtab.title) === 'string' ? selectedtab.title : selectedtab.titleName || 'unknown',
                                            tabName: typeof (tab.title) === 'string' ? tab.title : tab.titleName || 'unknown',
                                        }
}
                                >
                                    <button
                                        type="button"
                                        key={i}
                                        className={`btn btn-tab ${tab.active ? 'active' : ''} ${showLabels ? 'labelled' : ''} ${disabledTabClick ? 'disabled' : ''}`}
                                        data-visible-index={tab.visibleIndex}
                                        data-visible-count={tab.visibleCount}
                                        onClick={(ev) => onTabClick(ev, tab, i)}
                                        data-testid={dataTestId ? `${dataTestId}.tab-${tab.id || i}` : undefined}
                                        {...getClickAttrs({
                                            category: clickCategory,
                                            context: `Tab click - ${typeof (tab.title) === 'string' ? tab.title : tab.titleName || 'unknown'}`,
                                            location: clickLocation,
                                        })}
                                    >
                                        <div className={`d-flex flex-column align-items-start fill-height`}>
                                            {showLabels && tab.label && (
                                                <div className={`text-left mb-auto text-light-gray label`} data-testid={dataTestId ? `${dataTestId}.tab-${tab.id || i}.label` : undefined}>
                                                    {tab.label}
                                                </div>
                                            )}
                                            <div className={`text-left ${showLabels && tab.label ? '' : 'mt-auto'}`} data-testid={dataTestId ? `${dataTestId}.tab-${tab.id || i}.title` : undefined}>
                                                {typeof tab.title === 'function' ? tab.title() : tab.title}
                                            </div>
                                        </div>
                                    </button>
                                </TrackedClick>
                            </React.Fragment>
                        );
                    }
                    return null;
                })}
            </div>
        </div>
    );
};

TabBar.propTypes = {
    noPadding: PropTypes.bool,
    handleTabClickV3: PropTypes.func,
};
TabBar.defaultProps = {
    noPadding: false,
    handleTabClickV3: () => {},
};

export default TabBar;
